module.exports = __webpack_public_path__ + "img/antet-img.a93788a5.jpg";